import { border } from '../styles';

export const gridBorder = {
    position: 'relative',
    fontFamily: 'roboto',
    borderBottom: border,
    borderRight: border
};

export const gridCell = {
    padding: '0px 10px',
    color: '#414141',
    fontSize: 14
};

export const primaryColumnLink = {
    textDecoration: 'none',
    color: '#1101BE',
    fontWeight: 500,
    cursor: 'pointer'
};
